console.log('custom script running');

// Target all buttons and cards on the website
const buttonAndCardElements = document.querySelectorAll('button, .button, .card, .card-wrapper');
console.log('Found button and card elements: ', buttonAndCardElements);

// Apply random rotation if elements are found
buttonAndCardElements.forEach(function(element) {
  const randomRotation = Math.random() < 0.5 ? '-1deg' : '1deg'; // Random clockwise or counterclockwise
  console.log('Random rotation applied: ', randomRotation); // Log the random rotation
  element.style.setProperty('--initial-rotation', randomRotation); // Apply random rotation
});
